import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Inbox } from "lucide-react";
import api from "@/lib/api";
import { getInitials, avatarColor } from "@/lib/avatar";
import { useI18n } from "@/context/I18nContext";

export default function SocialInbox({ onOpenThread, refreshKey }) {
  const { t } = useI18n();
  const [convos, setConvos] = useState([]);
  useEffect(() => { api.get("/social/inbox").then(({ data }) => setConvos(data)).catch(() => {}); }, [refreshKey]);

  if (!convos.length) return (
    <div className="text-center py-20 text-[var(--rc-muted)]" data-testid="social-inbox-empty">
      <Inbox size={40} className="mx-auto mb-3 text-[var(--rc-gold)]" />
      <p>{t("s_no_messages")}</p>
      <p className="text-xs mt-1">{t("s_message_friend")}</p>
    </div>
  );

  return (
    <div className="divide-y divide-[var(--rc-border)]" data-testid="social-inbox">
      {convos.map((c) => (
        <button key={c.peer.id} onClick={() => onOpenThread(c.peer)} data-testid={`social-convo-${c.peer.id}`} className="w-full flex items-center gap-3 py-3 text-left">
          <div className="h-12 w-12 rounded-2xl grid place-items-center text-[var(--rc-gold)] font-semibold border-2 border-[var(--rc-gold)] overflow-hidden shrink-0" style={{ backgroundColor: c.peer.avatar ? "var(--rc-bg)" : avatarColor(c.peer.name) }}>
            {c.peer.avatar ? <img src={c.peer.avatar} alt="" className="h-full w-full object-cover" /> : getInitials(c.peer.name)}
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-medium truncate">{c.peer.name}</div>
            <div className="text-sm text-[var(--rc-muted)] truncate">{c.last.text}</div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className="text-[11px] text-[var(--rc-muted)]">{dayjs(c.last.created_at).format("HH:mm")}</span>
            {c.unread > 0 && <span className="h-5 min-w-5 px-1.5 grid place-items-center rounded-full bg-[var(--rc-gold)] text-black text-[11px] font-bold">{c.unread}</span>}
          </div>
        </button>
      ))}
    </div>
  );
}
